import CTALink from "@/components/CTA/variants/CtaLink/index";

export default CTALink;
